import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_CAS_NUMBER_LIST_FAILURE:
      return {
        title: t('message.title.error.get.cas.number.list'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
